import React from "react";
import { primaryColor, tuftsBlue } from "../constants/colors";
import styled from "styled-components";
import { imageBaseUrl } from "../constants/ApiConstants";
import { getFulleDateTimeFromEpoch } from "../utils/utils";
import { Link } from "react-router-dom";

const ChatMessageItem = ({ isUser, userId, msg, onJoinMeetingTap }) => {
  const getImageComponent = (image) => {
    return (
      <div className="img-chat">
        <Link target="_blank" to={`${imageBaseUrl}${image}`}>
          <img className="chat-image-preview" alt="chatimage preview" src={`${imageBaseUrl}${image}`} />
        </Link>
      </div>
    );
  };
  const getVideoComponent = (video) => {
    return (
      <div className="video-chat">
        <video className="chat-video-preview" alt="videopreview preview" controls src={`${imageBaseUrl}${video}`} />
      </div>
    );
  };
  const getTextComponent = (text, active) => {
    return <div className={`text-chat ${active && "active-chat"}`}>{text}</div>;
  };
  const getVideoCallComponent = (message) => {
    return (
      <div className={`videocall-card`}>
        <div className="video-call-content">
          <h4>
            VIDEO <span>CONSULTATION</span>
          </h4>
          <p>{message.senderUser?.name} is asking you to join the video consultation.</p>
          <h5>{getFulleDateTimeFromEpoch(parseInt(message.videoCall.time))}</h5>
        </div>
        <div className="grey-bottom" onClick={() => onJoinMeetingTap(message)}>
          JOIN MEETING
        </div>
      </div>
    );
  };

  return (
    <ChatMessageItemWrapper style={isUser && msg.senderUser.userId == isUser?.id ? { marginLeft: "auto", width: "max-content", maxWidth: "75%" } : { marginRight: "auto", width: "max-content", maxWidth: "75%" }}>
      {msg.msgType === "text" && getTextComponent(msg.msg, !(isUser && msg.senderUser.userId == isUser?.id))}
      {msg.msgType === "image" && getImageComponent(msg.image)}
      {msg.msgType === "video" && getVideoComponent(msg)}
      {msg.msgType === "videoCall" && getVideoCallComponent(msg)}
      <span className="time" style={isUser && msg.senderUser.userId == isUser?.id ? { marginLeft: "auto" } : { marginRight: "auto" }}>
        {getFulleDateTimeFromEpoch(parseInt(msg.id))}
      </span>
    </ChatMessageItemWrapper>
  );
};

export default ChatMessageItem;

const ChatMessageItemWrapper = styled.div`
  font-weight: 400;
  margin-bottom: 18px;

  .text-chat {
    background: #f1f1f1;
    color: #353535;
    border-radius: 14px;
    font-weight: 400;
    padding: 6px 12px;
    width: max-content;
    margin-left: auto;
    font-size: 0.9rem;
    &.active-chat {
      background: ${primaryColor};
      color: #fff;
      margin-right: auto;
      margin-left: 0;
    }
  }
  .videocall-card {
    width: 100%;
    border-radius: 14px;
    .video-call-content {
      padding: 14px 12px;
    }
    .grey-bottom {
      color: #fff;
      background-color: #6b6b6b;
      text-align: center;
      padding-top: 12px;
      padding-bottom: 12px;
      border-bottom-left-radius: 14px;
      border-bottom-right-radius: 14px;
      font-size: 0.8rem;
    }
    p {
      font-size: 0.85rem;
      color: #777777;
      margin-bottom: 4px !important;
    }
    h4 {
      font-size: 0.9rem;
      margin-bottom: 4px !important;
      span {
        font-weight: 400;
      }
    }
    h5 {
      color: #9e9e9e;
      margin-bottom: 0px !important;
      font-size: 0.85rem;
      color: ${tuftsBlue};
    }
    background-color: #f3f3f3;
  }

  .img-chat,
  .video-chat {
    border-radius: 14px;
    padding: 4px;
    img,
    video {
      border-radius: 14px;
      padding: 4px;
      max-width: 100%;
      width: 250px;
    }
  }

  .time {
    font-size: 0.85rem;
    color: #9e9e9e;
    width: max-content;
  }
`;
